import { render } from "./Video.vue?vue&type=template&id=3a923e41"
import script from "./Video.vue?vue&type=script&lang=ts"
export * from "./Video.vue?vue&type=script&lang=ts"
script.render = render

export default script